export default "__VITE_ASSET__ClIt$2vG__"